import React from "react";
import {Button, Card, Checkbox, Col, DatePicker, Divider, Form, Input, Row, Select, Space, Table} from "antd";
import {
    AuthenticatedGetToApi,
    AuthenticatedPostToApi,
    FILEDOWNLOADAuthenticatedPostToApi,
    UnauthenticatedPostToApi
} from "../../helpers/api";
import {DownloadOutlined} from "@ant-design/icons";
const { Option } = Select;

function StopLogByOfficer() {
    const [form] = Form.useForm();
    const [DepartmentList, SetDepartmentList] = React.useState([])
    const [DepartmentEmployeeList, SetDepartmenttEmployeeList] = React.useState([])
    const [dataSource, SetDataSource] = React.useState({})
    const [savedReq, SetSavedReq] = React.useState({})
    const [isLoading, setIsLoading] = React.useState(false)
    
    const onFinish = (values) => {
        setIsLoading(true)
        SetDataSource({})
        SetSavedReq(values)
        AuthenticatedPostToApi('/api/Report/StopLogOfficerReport',values).then(r=>{
            setIsLoading(false)
            SetDataSource(r)
        }).catch(()=>setIsLoading(false))
    };

    const runExport = async (pdf) => {
        setIsLoading(true)
        FILEDOWNLOADAuthenticatedPostToApi('/api/ReportExport/StopLogOfficerReport?pdf='+pdf,savedReq).then(r=>{
            setIsLoading(false)
            const blob = new Blob([r]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `ReportExport-${+new Date()}.`+ (pdf?'pdf':'xlsx');
            link.click();
            link.remove();
        }).catch(()=>setIsLoading(false))
    }

    const LoadDepts = async () => {
        let r = await AuthenticatedGetToApi('/api/Central/MyDepartmentList')
        SetDepartmentList(r)
    }

    const LoadEmployees = async (dept) => {
        let r = await AuthenticatedPostToApi('/api/Central/DepartmentEmployeeList', {sDept:dept})
        console.log(r)
        SetDepartmenttEmployeeList(r)
    }

    React.useEffect(()=>{
        LoadDepts();
    },[])

    const columns = [
        {
            title: 'EmpID',
            dataIndex: 'EmpID',
            key: 'EmpID',
        },
        {
            title: 'Male_IM',
            dataIndex: 'Male_IM',
            key: 'Male_IM',
        },
        {
            title: 'Male_A',
            dataIndex: 'Male_A',
            key: 'Male_A',
        },
        {
            title: 'Male_B',
            dataIndex: 'Male_B',
            key: 'Male_B',
        },
        {
            title: 'Male_U',
            dataIndex: 'Male_U',
            key: 'Male_U',
        },
        {
            title: 'Male_W',
            dataIndex: 'Male_W',
            key: 'Male_W',
        },
        {
            title: 'Male_Total',
            dataIndex: 'Male_Total',
            key: 'Male_Total',
        },
        {
            title: 'Female_IM',
            dataIndex: 'Female_IM',
            key: 'Female_IM',
        },
        {
            title: 'Female_A',
            dataIndex: 'Female_A',
            key: 'Female_A',
        },
        {
            title: 'Female_B',
            dataIndex: 'Female_B',
            key: 'Female_B',
        },
        {
            title: 'Female_U',
            dataIndex: 'Female_U',
            key: 'Female_U',
        },
        {
            title: 'Female_W',
            dataIndex: 'Female_W',
            key: 'Female_W',
        },
        {
            title: 'Female_Total',
            dataIndex: 'Female_Total',
            key: 'Female_Total',
        },
    ]
    return (
        <div>
            <Card size="small" title={"Stop Log By Officer Report"}  style={{ width: "100%", marginTop:10 }}>

                <Form
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    layout={"horizontal"}
                    form={form}
                >
                    <Space direction="horizontal">
                        <Form.Item
                            name="reportTitle"
                            rules={[{ required: true, message: 'Report Title is Required' }]}
                        >
                            <Input addonBefore="Report Title"  placeholder="Report Title" allowClear={true} />
                        </Form.Item>


                        <Form.Item
                            name="sDept"
                            rules={[{ required: true, message: 'Department is Required' }]}
                        >
                            <Select showSearch={true} placeholder={"Department"} style={{ width: 150 }} allowClear={true} onChange={(e1,e2)=>{
                                console.log(e1)
                                LoadEmployees(e1)
                            }}>
                                {DepartmentList.map((v,idx)=>(
                                    <Option value={v.value?.toString()} key={'dept'+idx}>{v.key?.toString()}</Option>
                                ))}

                            </Select>
                        </Form.Item>


                        <Form.Item
                            name="empids"
                            rules={[{ required: true, message: 'Employee is Required' }]}
                        >
                            <Select
                                showSearch={true}
                                placeholder={"Employee"} 
                                style={{ width: 150 }} 
                                allowClear={true} 
                                mode="multiple"
                                maxTagCount={'responsive'}
                                dropdownRender={(menu) => {
                                    return (
                                        <div>
                                            <div
                                                style={{ padding: "4px 8px 8px 8px", cursor: "pointer" }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            >
                                                <Checkbox
                                                    onChange={(e) => {
                                                        if (e.target.checked === true) {
                                                            let list = []
                                                            DepartmentEmployeeList.map((v,idx)=>{
                                                                list.push(v.empid?.toString())
                                                            })
                                                            form.setFieldsValue({
                                                                empids: list,
                                                            });
                                                        } else {
                                                            form.setFieldsValue({
                                                                empids: [],
                                                            });
                                                        }
                                                    }}
                                                >
                                                    Select all
                                                </Checkbox>
                                            </div>
                                            <Divider style={{ margin: "2px 0" }} />
                                            {menu}
                                        </div>
                                    );
                                }}
                            >
                                {DepartmentEmployeeList.map((v,idx)=>(
                                    <Option value={v.empid?.toString()} key={'dept'+idx}>{v.firstname?.toString()} {v.lastname?.toString()} ({v.empid?.toString()})</Option>
                                ))}

                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="sStartDate"
                            rules={[{ required: true, message: 'Start Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'Start Date'} format={'MM/DD/YYYY'}/>
                        </Form.Item>

                        <Form.Item
                            name="sEndDate"
                            rules={[{ required: true, message: 'End Date is Required' }]}
                        >
                            <DatePicker allowClear={true} placeholder={'End Date'} format={'MM/DD/YYYY'}/>
                        </Form.Item>

                    </Space>
                    <Form.Item>
                        <Button htmlType="submit" loading={isLoading}>
                            Generate Report
                        </Button>
                    </Form.Item>

                </Form>

            </Card>

            {Object.keys(dataSource).length>0 &&
                <Card size="small"  style={{ width: "100%", marginTop:10 }}>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(true)} loading={isLoading}>
                        Download PDF
                    </Button>
                    <Button type="primary" icon={<DownloadOutlined />} style={{ marginLeft:10 }} onClick={()=>runExport(false)} loading={isLoading}>
                        Download Excel
                    </Button>
                    
                    <h6>Stop Log Legend : American Indian or Alaskan Native (IM) Asian or Pacific Islander (A) Black (B) Unknown (U) White (W)</h6>
                    <h5>Stop Log - Gender Breakdown</h5>
                    {(dataSource && dataSource.AllStopsBreakdown) &&
                        <Table size="small" dataSource={dataSource.AllStopsBreakdown} columns={columns} pagination={false}/>
                    }

                    <h5>Stop Log - Ethnicity Breakdown</h5>
                    {(dataSource && dataSource.EthnicityAllStopsBreakdown) &&
                        <Table size="small" dataSource={dataSource.EthnicityAllStopsBreakdown} columns={columns} pagination={false}/>
                    }
                    
                    <h5>Stop Log - Summons Breakdown</h5>
                    {(dataSource && dataSource.SummonsBreakdown) &&
                        <Table size="small" dataSource={dataSource.SummonsBreakdown} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log - Warning Breakdown</h5>
                    {(dataSource && dataSource.WarningsBreakdown) &&
                        <Table size="small" dataSource={dataSource.WarningsBreakdown} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log - Arrest Breakdown</h5>
                    {(dataSource && dataSource.ArrestsBreakdown) &&
                        <Table size="small" dataSource={dataSource.ArrestsBreakdown} columns={columns} pagination={false}/>
                    }

                    <h5>Stop Log - Ethnicity Summons Breakdown</h5>
                    {(dataSource && dataSource.EthnicitySummonsBreakdown) &&
                        <Table size="small" dataSource={dataSource.EthnicitySummonsBreakdown} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log - Ethnicity Warning Breakdown</h5>
                    {(dataSource && dataSource.EthnicityWarningsBreakdown) &&
                        <Table size="small" dataSource={dataSource.EthnicityWarningsBreakdown} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log -  EthnicityArrest Breakdown</h5>
                    {(dataSource && dataSource.EthnicityArrestsBreakdown) &&
                        <Table size="small" dataSource={dataSource.EthnicityArrestsBreakdown} columns={columns} pagination={false}/>
                    }

                    <h5>Stop Log -  Age Under 21</h5>
                    {(dataSource && dataSource.AgeUnder21) &&
                        <Table size="small" dataSource={dataSource.AgeUnder21} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log -  Age 22-43</h5>
                    {(dataSource && dataSource.Age22to43) &&
                        <Table size="small" dataSource={dataSource.Age22to43} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log - Age 44-65</h5>
                    {(dataSource && dataSource.Age44to65) &&
                        <Table size="small" dataSource={dataSource.Age44to65} columns={columns} pagination={false}/>
                    }
                    <h5>Stop Log -  Age 66+</h5>
                    {(dataSource && dataSource.AgeOver66) &&
                        <Table size="small" dataSource={dataSource.AgeOver66} columns={columns} pagination={false}/>
                    }

                </Card>
            }
        </div>
    );
}

export default StopLogByOfficer;